import styled from "styled-components/macro";

import icon_star from "../../assets/icons/icon_star.svg"

export const Section = styled.section<{ bgImage?: string }>`
  width: 100%;
  height: 550px;
  background-image: ${({ bgImage }) => bgImage ? `url(${bgImage})` : "none"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 30px;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 80px;
    
  @media (max-width: 1439px) {
    height: 540px;
    margin-bottom: 40px;
  }

  @media (max-width: 979px) {
    padding: 40px 12px 0;
    border-radius: 0;
  }
`;

export const MainTitle = styled.h2`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 65px;
  font-weight: 600;
  line-height: 105%;
  color: #fff;
  text-align: center;
  margin-bottom: 36px;
  max-width: 960px;

  @media (max-width: 1439px) {
    font-size: 45px;
  }

  @media (max-width: 979px) {
    font-size: 38px;
    margin-bottom: 40px;
  }
`

export const DecorText = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 36px;
    
  span {
    font-size: 22px;
    color: #fff;
    letter-spacing: -0.02em;
    text-align: center;
    
    @media (max-width: 979px) {
      font-size: 16px;
    }
  }

  @media (max-width: 979px) {
    flex-direction: column;
    margin-bottom: 100px;
  } 
`

export const Icon = styled.span`
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${icon_star});

  @media (max-width: 979px) {
    width: 12px;
    height: 12px;
  }
`

export const AnimatedText = styled.span`
  @media (max-width: 979px) {
    display: block;
    min-height: 160px;
  }
`
